import { Box, Flex, Text, Button, Icon, VStack } from "@chakra-ui/react";
import { SearchIcon, InfoIcon } from "@chakra-ui/icons";
import { FaFilter } from "react-icons/fa";

interface EmptyStateProps {
  mode: "initial" | "no-results";
  onClearFilters?: () => void;
}

export default function EmptyState({ mode, onClearFilters }: EmptyStateProps) {
  const isInitial = mode === "initial";

  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      py={20}
      px={4}
      bg="gray.50"
      borderRadius="xl"
      borderWidth="1px"
      borderStyle="solid"
      borderColor="gray.200"
      textAlign="center"
      w="100%"
    >
      <VStack spacing={6}>
        <Box
          p={0}
          borderRadius="full"
          bg={isInitial ? "primaryAlpha.100" : "orange.50"}
          color={isInitial ? "primary" : "orange.400"}
        >
          <Icon as={isInitial ? FaFilter : SearchIcon} boxSize={12} />
        </Box>

        <VStack spacing={2}>
          <Text fontSize="xl" fontWeight="bold" color="gray.700" fontFamily="Lexend Deca">
            {isInitial ? "Comece sua busca" : "Nenhum resultado encontrado"}
          </Text>
          <Text color="gray.500" maxW="md">
            {isInitial
              ? "Selecione o intervalo de datas e os filtros desejados para visualizar as comissões do período."
              : "Não encontramos registros para os filtros aplicados. Tente ajustar os parâmetros ou limpar os filtros."}
          </Text>
        </VStack>

        {!isInitial && onClearFilters && (
          <Button
            colorScheme="orange"
            variant="outline"
            leftIcon={<InfoIcon />}
            onClick={onClearFilters}
            borderRadius="lg"
            _hover={{ opacity: 0.8 }}
          >
            Limpar Filtros
          </Button>
        )}
      </VStack>
    </Flex>
  );
}
